import { forwardRef, ReactNode } from 'react';
import Link, { LinkProps } from 'next/link';

import { isDev } from '@restworld/utils-common';

export const V2Link = forwardRef<HTMLAnchorElement, V2LinkProps>(({ href, children, noV2Prefix, ...rest }, ref) => {
  const newHref = noV2Prefix
    ? href
    : typeof href === 'string'
    ? `/v2${href}`
    : { ...href, pathname: `/v2${href.pathname}` };

  return (
    <Link href={isDev ? href : newHref} ref={ref} {...rest}>
      {children}
    </Link>
  );
});
V2Link.displayName = 'V2Link';
export default V2Link;

interface V2LinkProps extends LinkProps {
  children: ReactNode;
  noV2Prefix?: boolean;
  className?: string;
}
